import React, { useState, useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';

const POSITION_STYLES = {
  top: '-translate-x-1/2 -translate-y-full',
  bottom: '-translate-x-1/2 translate-y-2',
  left: '-translate-x-full -translate-y-1/2',
  right: 'translate-x-2 -translate-y-1/2',
};

// Tooltip via portal — escapa `overflow: hidden` de containers pai.
// Aparece em hover/focus do child. Não mostra em dispositivos touch
// (mouseenter não dispara; focus sim pra teclado).
const Tooltip = ({ children, content, position = 'top', delay = 200, className = '' }) => {
  const [visible, setVisible] = useState(false);
  const [coords, setCoords] = useState({ x: 0, y: 0 });
  const triggerRef = useRef(null);
  const timerRef = useRef(null);

  const show = () => {
    timerRef.current = setTimeout(() => {
      if (!triggerRef.current) return;
      const rect = triggerRef.current.getBoundingClientRect();
      let x, y;
      if (position === 'top') {
        x = rect.left + rect.width / 2;
        y = rect.top;
      } else if (position === 'bottom') {
        x = rect.left + rect.width / 2;
        y = rect.bottom;
      } else if (position === 'left') {
        x = rect.left;
        y = rect.top + rect.height / 2;
      } else {
        x = rect.right;
        y = rect.top + rect.height / 2;
      }
      setCoords({ x, y });
      setVisible(true);
    }, delay);
  };

  const hide = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
    setVisible(false);
  };

  useEffect(() => () => clearTimeout(timerRef.current), []);

  if (!content) return children;

  return (
    <>
      <span
        ref={triggerRef}
        onMouseEnter={show}
        onMouseLeave={hide}
        onFocus={show}
        onBlur={hide}
        className="inline-block"
      >
        {children}
      </span>
      {visible &&
        createPortal(
          <div
            role="tooltip"
            className={`fixed pointer-events-none px-2 py-1 text-xs text-white bg-gray-900 rounded shadow-lg whitespace-nowrap z-[70] ${POSITION_STYLES[position]} ${className}`}
            style={{ left: coords.x, top: coords.y }}
          >
            {content}
          </div>,
          document.body
        )}
    </>
  );
};

export default Tooltip;
